<template>
    <div>
        <slot></slot>
        <yxt-button type="plain" @click="cancel">{{$t('pc_biz_udp_btn_cancel' /* 取消 */)}}</yxt-button>
        <yxt-button type="primary" @click="submit">{{$t('pc_save' /* 保存 */)}}</yxt-button>
    </div>
</template>
<script>
import { Button } from 'yxt-pc';
export default {
  components: {
    'yxt-button': Button
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    submit() {
      this.$emit('submit');
    }
  }
};
</script>
